import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import queryString from 'query-string';

import styles from './link.module.less';
import { LinkPropTypes } from '../prop-types';

const FilterLink = ({ filter, queryParams = {} }) => (
  <Link
    className={classNames(styles['filter-link'], {
      [styles['filter-link-active']]:
        queryParams[filter.param] === filter.paramValue ||
        (!filter.paramValue && !queryParams[filter.param]),
    })}
    to={{
      search: `${queryString.stringify({
        ...queryParams,
        [filter.param]: filter.paramValue || undefined,
      })}`,
    }}
  >
    {filter.label}
  </Link>
);

FilterLink.propTypes = {
  filter: LinkPropTypes,
  queryParams: PropTypes.object,
};

export default FilterLink;
